<template>
  <block-content :blocks="blocks" :serializers="serializers"></block-content>
</template>

<script>
import RichTextImage from "./RichTextImage";
import RichTextGallery from "./RichTextGallery";
import BlockContent from "sanity-blocks-vue-component";

export default {
  name: "StandardBlockContent",
  components: {
    BlockContent
  },
  props: {
    blocks: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      serializers: {
        types: {
          image: RichTextImage,
          gallery: RichTextGallery
        }
      }
    }
  }
};
</script>

